var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddLeadsAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8125 80.5C61.9039 80.5 79.8125 62.5914 79.8125 40.5C79.8125 18.4086 61.9039 0.5 39.8125 0.5C17.7211 0.5 -0.1875 18.4086 -0.1875 40.5C-0.1875 62.5914 17.7211 80.5 39.8125 80.5Z",
    fill: "url(#paint0_linear_5845_161874)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5845_161874",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 81,
    height: 81
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8115 80.5C61.9029 80.5 79.8115 62.5914 79.8115 40.5C79.8115 18.4086 61.9029 0.5 39.8115 0.5C17.7201 0.5 -0.188477 18.4086 -0.188477 40.5C-0.188477 62.5914 17.7201 80.5 39.8115 80.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5845_161874)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M42.6338 22.4883L79.812 45.8145V80.502L71.2018 61.8343L39.4785 26.2611L40.1913 23.8466L42.6338 22.4883Z",
    fill: "#006546"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5845_161874",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 81,
    height: 81
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8115 80.5C61.9029 80.5 79.8115 62.5914 79.8115 40.5C79.8115 18.4086 61.9029 0.5 39.8115 0.5C17.7201 0.5 -0.188477 18.4086 -0.188477 40.5C-0.188477 62.5914 17.7201 80.5 39.8115 80.5Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5845_161874)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M39.3209 22.707L78.2014 54.7243L72.1738 64.0371L71.2181 61.8449L39.088 25.7388L39.3209 22.707Z",
    fill: "#C327D1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5845_161874",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 81,
    height: 81
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8379 80.5C61.9293 80.5 79.8379 62.5914 79.8379 40.5C79.8379 18.4086 61.9293 0.5 39.8379 0.5C17.7465 0.5 -0.162109 18.4086 -0.162109 40.5C-0.162109 62.5914 17.7465 80.5 39.8379 80.5Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5845_161874)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M38.6418 50.4922L64.4735 72.1287L53.9105 95.7747L45.3004 77.1069L29.0732 61.9066L31.6166 55.3216L38.6418 50.4922Z",
    fill: "#006546"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_5845_161874",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 81,
    height: 81
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8115 80.5C61.9029 80.5 79.8115 62.5914 79.8115 40.5C79.8115 18.4086 61.9029 0.5 39.8115 0.5C17.7201 0.5 -0.188477 18.4086 -0.188477 40.5C-0.188477 62.5914 17.7201 80.5 39.8115 80.5Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_5845_161874)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.7653 54.207L54.3209 77.9457L46.6056 79.9951L45.3161 77.1172L29.2266 62.0547L30.7653 54.207Z",
    fill: "#C327D1"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6797 50.3016C39.1336 50.3016 36.6918 49.2901 34.8915 47.4898C33.0911 45.6894 32.0797 43.2476 32.0797 40.7016C32.0797 40.2772 31.9111 39.8702 31.6111 39.5702C31.311 39.2701 30.904 39.1016 30.4797 39.1016C30.0553 39.1016 29.6484 39.2701 29.3483 39.5702C29.0483 39.8702 28.8797 40.2772 28.8797 40.7016C28.8797 43.2476 27.8683 45.6894 26.0679 47.4898C24.2676 49.2901 21.8258 50.3016 19.2797 50.3016C18.8553 50.3016 18.4484 50.4701 18.1483 50.7702C17.8483 51.0702 17.6797 51.4772 17.6797 51.9016C17.6797 52.3259 17.8483 52.7329 18.1483 53.0329C18.4484 53.333 18.8553 53.5016 19.2797 53.5016C21.8258 53.5016 24.2676 54.513 26.0679 56.3133C27.8683 58.1137 28.8797 60.5555 28.8797 63.1016C28.8797 63.5259 29.0483 63.9329 29.3483 64.2329C29.6484 64.533 30.0553 64.7016 30.4797 64.7016C30.904 64.7016 31.311 64.533 31.6111 64.2329C31.9111 63.9329 32.0797 63.5259 32.0797 63.1016C32.0797 60.5555 33.0911 58.1137 34.8915 56.3133C36.6918 54.513 39.1336 53.5016 41.6797 53.5016C42.104 53.5016 42.511 53.333 42.8111 53.0329C43.1111 52.7329 43.2797 52.3259 43.2797 51.9016C43.2797 51.4772 43.1111 51.0702 42.8111 50.7702C42.511 50.4701 42.104 50.3016 41.6797 50.3016Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0797 35.1016C62.1714 35.0973 60.3425 34.3374 58.9932 32.9881C57.6438 31.6387 56.8839 29.8098 56.8797 27.9016C56.8797 27.4772 56.7111 27.0702 56.4111 26.7702C56.111 26.4701 55.704 26.3016 55.2797 26.3016C54.8553 26.3016 54.4484 26.4701 54.1483 26.7702C53.8483 27.0702 53.6797 27.4772 53.6797 27.9016C53.6755 29.8098 52.9155 31.6387 51.5662 32.9881C50.2168 34.3374 48.3879 35.0973 46.4797 35.1016C46.0553 35.1016 45.6484 35.2701 45.3483 35.5702C45.0483 35.8702 44.8797 36.2772 44.8797 36.7016C44.8797 37.1259 45.0483 37.5329 45.3483 37.8329C45.6484 38.133 46.0553 38.3016 46.4797 38.3016C48.3879 38.3058 50.2168 39.0657 51.5662 40.4151C52.9155 41.7644 53.6755 43.5933 53.6797 45.5016C53.6797 45.9259 53.8483 46.3329 54.1483 46.6329C54.4484 46.933 54.8553 47.1016 55.2797 47.1016C55.704 47.1016 56.111 46.933 56.4111 46.6329C56.7111 46.3329 56.8797 45.9259 56.8797 45.5016C56.8839 43.5933 57.6438 41.7644 58.9932 40.4151C60.3425 39.0657 62.1714 38.3058 64.0797 38.3016C64.504 38.3016 64.911 38.133 65.2111 37.8329C65.5111 37.5329 65.6797 37.1259 65.6797 36.7016C65.6797 36.2772 65.5111 35.8702 65.2111 35.5702C64.911 35.2701 64.504 35.1016 64.0797 35.1016Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0797 24.7016C33.3527 24.7016 34.5736 25.2073 35.4738 26.1074C36.374 27.0076 36.8797 28.2285 36.8797 29.5016C36.8797 29.9259 37.0483 30.3329 37.3483 30.6329C37.6484 30.933 38.0553 31.1016 38.4797 31.1016C38.904 31.1016 39.311 30.933 39.6111 30.6329C39.9111 30.3329 40.0797 29.9259 40.0797 29.5016C40.0797 28.2285 40.5854 27.0076 41.4856 26.1074C42.3858 25.2073 43.6066 24.7016 44.8797 24.7016C45.304 24.7016 45.711 24.533 46.0111 24.2329C46.3111 23.9329 46.4797 23.5259 46.4797 23.1016C46.4797 22.6772 46.3111 22.2702 46.0111 21.9702C45.711 21.6701 45.304 21.5016 44.8797 21.5016C43.6066 21.5016 42.3858 20.9958 41.4856 20.0957C40.5854 19.1955 40.0797 17.9746 40.0797 16.7016C40.0797 16.2772 39.9111 15.8702 39.6111 15.5702C39.311 15.2701 38.904 15.1016 38.4797 15.1016C38.0553 15.1016 37.6484 15.2701 37.3483 15.5702C37.0483 15.8702 36.8797 16.2772 36.8797 16.7016C36.8797 17.9746 36.374 19.1955 35.4738 20.0957C34.5736 20.9958 33.3527 21.5016 32.0797 21.5016C31.6553 21.5016 31.2484 21.6701 30.9483 21.9702C30.6483 22.2702 30.4797 22.6772 30.4797 23.1016C30.4797 23.5259 30.6483 23.9329 30.9483 24.2329C31.2484 24.533 31.6553 24.7016 32.0797 24.7016Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0797 64.7016C48.9633 64.7016 49.6797 63.9852 49.6797 63.1016C49.6797 62.2179 48.9633 61.5016 48.0797 61.5016C47.196 61.5016 46.4797 62.2179 46.4797 63.1016C46.4797 63.9852 47.196 64.7016 48.0797 64.7016Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0797 43.9016C40.9633 43.9016 41.6797 43.1852 41.6797 42.3016C41.6797 41.4179 40.9633 40.7016 40.0797 40.7016C39.196 40.7016 38.4797 41.4179 38.4797 42.3016C38.4797 43.1852 39.196 43.9016 40.0797 43.9016Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8797 35.9016C21.7633 35.9016 22.4797 35.1852 22.4797 34.3016C22.4797 33.4179 21.7633 32.7016 20.8797 32.7016C19.996 32.7016 19.2797 33.4179 19.2797 34.3016C19.2797 35.1852 19.996 35.9016 20.8797 35.9016Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2797 24.7016C60.1633 24.7016 60.8797 23.9852 60.8797 23.1016C60.8797 22.2179 60.1633 21.5016 59.2797 21.5016C58.396 21.5016 57.6797 22.2179 57.6797 23.1016C57.6797 23.9852 58.396 24.7016 59.2797 24.7016Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2316 56.2224C62.1153 56.2224 62.8316 55.5061 62.8316 54.6224C62.8316 53.7387 62.1153 53.0224 61.2316 53.0224C60.348 53.0224 59.6316 53.7387 59.6316 54.6224C59.6316 55.5061 60.348 56.2224 61.2316 56.2224Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5845_161874",
    x1: 39.8125,
    y1: 0.5,
    x2: 39.8125,
    y2: 80.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B649F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLeadsAi);
export default __webpack_public_path__ + "static/media/add_leads_ai.d3f54daf0472a37b14139fcff62bbba8.svg";
export { ForwardRef as ReactComponent };